import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrinityService } from 'app/services/trinity/trinity.service';
import { GetUserDrivesOptions, GoogleDrive, Paginated } from 'app/types';

@Injectable({
  providedIn: 'root',
})
export class GdrivesService {
  private readonly endpoint: string = '/drive';

  constructor(private trinityService: TrinityService) {}

  getUserDrives(
    options: GetUserDrivesOptions,
  ): Observable<Paginated<GoogleDrive>> {
    const params: { [key: string]: string } = {
      limit: options.limit.toString(),
    };

    if (options.next_page_token)
      params['next_page_token'] = options.next_page_token;

    return this.trinityService.get(`${this.endpoint}/google`, {
      params,
      authorized: true,
    });
  }
}
